module.exports = __webpack_public_path__ + "static/media/0022.7ac3bb28.jpg";